import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
} from "@mui/material";
import { useRef } from "react";

export const MultiDeleteDialog = ({
  gridList,
  rows,
  selectedRowsData,
  data,
  openDialog,
  setOpenDialog,
  handleMultiDeleteConfirmation,
}) => {
  let variants = [];
  let selectedRows = [];
  if (gridList.gridPage === "screens") {
    selectedRows = rows?.filter((row) =>
      selectedRowsData?.includes(parseInt(row?.uid))
    );
    selectedRows?.forEach((screen) => {
      variants.push([
        ...data.screens?.filter(
          (i) =>
            parseInt(i?.list_number) === parseInt(screen?.list_number) &&
            i?.list_isDeleted === 0 &&
            i?.list_variant !== 0
        ),
      ]);
    });
  }

  if (gridList.gridPage === "userTypes") {
    selectedRows = rows?.filter((row) =>
      selectedRowsData?.includes(parseInt(row?.uid))
    );
    selectedRows?.forEach((screen) => {
      variants.push([
        ...data.users?.filter(
          (i) =>
            parseInt(i?.user_details?.userType) ===
              parseInt(screen?.userType_ref) && i?.user_isDeleted === 0
        ),
      ]);
    });
  }

  const scrollRef = useRef(null);
  // function scrollTo(ref) {
  //     console.log(ref)
  //     if (!ref.current) return;
  //     ref.current.scrollIntoView({ behavior: "smooth" });
  //   }

  //   const [isVisible, setIsVisible] = useState(false);

  //   useEffect(() => {
  //     console.log('here')
  //     // const handleScroll = () => {
  //       if (scrollRef.current) {
  //         const rect = scrollRef.current.getBoundingClientRect();
  //         const isVisible = (
  //           rect.top >= 0 &&
  //           rect.left >= 0 &&
  //           rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
  //           rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  //         );
  //         setIsVisible(isVisible);
  //     //   }
  //     }
  // },[scrollRef])

  return (
    <Dialog
      open={openDialog}
      // fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={() => setOpenDialog(!openDialog)}
      onBackdropClick={() => setOpenDialog(!openDialog)}
    >
      <DialogContent sx={{ px: 4, py: 4, position: "relative" }}>
        <IconButton
          size="medium"
          onClick={() => setOpenDialog(!openDialog)}
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
        >
          X
        </IconButton>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Box
              sx={{
                // mb: 3,
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography sx={{ mb: 1 }} variant="h2">
                Delete Rows
              </Typography>

              <Typography variant="body1">
                {gridList.gridPage === "screens"
                  ? "Are you sure you want to delete the selected screen(s)? Deleting these screens will also delete their associated variants:"
                  : gridList.gridPage === "userTypes"
                  ? "Are you sure you want to delete the selected userType(s)? Deleting this user types may cause issues for the following users:"
                  : "Are you sure you want to delete the selected row(s)?"}
              </Typography>
              {(gridList.gridPage === "screens" ||
                gridList.gridPage === "userTypes") &&
                variants?.length > 0 && (
                  <List
                    sx={{
                      width: "100%",
                      //  maxWidth: 500,
                      bgcolor: "background.paper",
                      position: "relative",
                      overflow: "scroll",
                      maxHeight: 300,
                      "& ul": { padding: 0 },
                    }}
                    subheader={<li />}
                  >
                    {" "}
                    {selectedRows?.map((screen, i) => (
                      <>
                        <li
                          key={`section-${screen.uid}`}
                          ref={i + 1 === selectedRows.length ? scrollRef : null}
                        >
                          <ul>
                            {variants[i].length > 0 && (
                              <ListSubheader sx={{ paddingBottom: 0 }}>
                                {screen.list_name
                                  ? screen.list_name
                                  : screen?.userType_name
                                  ? screen.userType_name
                                  : null}
                              </ListSubheader>
                            )}

                            {variants[i]?.map((i) => (
                              <ListItem
                                sx={{ p: 0 }}
                                key={`item-${
                                  screen.list_number
                                    ? screen.list_number
                                    : screen.user_number
                                }-${i}`}
                              >
                                <ListItemText
                                  sx={{ fontSize: 8 }}
                                  inset
                                  primary={
                                    i.list_name
                                      ? `• ${i.list_name}`
                                      : `• ${i.user_name}`
                                  }
                                />
                              </ListItem>
                            ))}
                          </ul>
                        </li>
                      </>
                    ))}
                  </List>
                )}
              {/* {selectedRowsData.length > 2 && <Button variant='' onClick={() => scrollTo(scrollRef)} sx={{fontSize:11, color: Colours.gsblue, alignSelf:'flex-end'}}>
        Scroll to end
      </Button>} */}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "1rem",
            }}
          >
            <Button
              onClick={() => setOpenDialog(!openDialog)}
              size="medium"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleMultiDeleteConfirmation}
              size="medium"
              variant="contained"
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
